import { Backdrop } from "@mui/material";
import styleSheet from "./style.module.scss";
import LoadingPlanet from "./loading-component";
import { Canvas, useThree } from "@react-three/fiber";
import { useEffect, useState } from "react";
import { setSessionData } from "../../../../utils/sessionstorage";
import OrbitLoading from "./orbit-loading";
import { useNavigate, useParams } from "react-router";
import { loadingProps } from "./interface";
import { useDispatch, useSelector } from "react-redux";
import { getOrbitDetails } from "../../../../feature/orbit-slice";
import { setloading } from "../../../../feature/loading-slice";
import SplashComponent from "./splash-component";

const LoadingScreen = (props: loadingProps) => {
  const { mode = "appLoading" } = props;
  const [onOpen, setOnOpen] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [openSplashScreen, setOpenSplashScreen] = useState(false);
  const orbitSlice = useSelector(getOrbitDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { encryptData, inviteEncryptData } = useParams();

  const getFadeOut = (fade: any) => {
    setTimeout(() => {

      if(!encryptData && !inviteEncryptData){
        setOpenSplashScreen(true);
      }else{
        onCloseLoading();
      }
      
    }, 1000);
  };

  useEffect(() => {
    setOnOpen(true);
  }, [mode]);

  const handleLoadingClose = () => {
    // navigate("/orbit");
    // navigate({
    //   pathname: "/orbit",
    //     search: `?id=${orbitSlice.selectOrbit}&map=0&fr=list`
    // });
    dispatch(setloading(false));
  };
  const onCloseLoading = () => {
    // setIsFadingOut(true);
    // setTimeout(() => {
    setOnOpen(false);
    setSessionData("loading", "0");
    // }, 1000);
  };

  const renderLoadingContent = () => {
    switch (mode) {
      case "orbitLoading":
        return <OrbitLoading loadingClose={handleLoadingClose} />;
      case "appLoading":
      default:
        return <LoadingPlanet getFadeOut={getFadeOut} />;
    }
  };

  return (
    <div>
      <Backdrop
        className={`${isFadingOut ? styleSheet.fadeOut : ""}`}
        sx={(theme: any) => ({
          color: "#fff",
          zIndex: theme.zIndex.drawer + 10,
          backgroundColor: "#1e1920",
        })}
        open={onOpen}
      >
        {openSplashScreen ? (
          <SplashComponent onCloseLoading={onCloseLoading} />
        ) : (
          <Canvas>{renderLoadingContent()}</Canvas>
        )}
      </Backdrop>
    </div>
  );
};
export default LoadingScreen;
